import React, { useEffect, useState, useMemo } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  Button
} from "reactstrap";
import * as moment from "moment";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import ConsultaLista from "../../Components/Common/ConsultaLista";
import { api } from "../../config";
import { ToastContainer } from 'react-toastify';
import Loader from "../../Components/Common/Loader";
import { fetchComAuth } from "../../common/api";
import ModalQueroExpor from "../../Layouts/ModalQueroExpor";

const ListaEspera = ({}) => {
  const [dados, setDados] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [feiraSelecionada, setFeiraSelecionada] = useState('');
  const [modalLista, setModalLista] = useState(false); 

  const authUser = JSON.parse(sessionStorage.getItem("authUser")) || {};
  const userData = authUser.user || authUser;
  const userType = userData.tipo || '';
  
  const userFeirasIds = userData.feiras?.map(item => item.feira_id) || [];
  const [feiraSelecionadaId, setFeiraSelecionadaId] = useState(-1);
  const [paises, setPaises] = useState([]);

  const fetchDados = async () => {
      setIsLoading(true);
      try {
        const response = await fetchComAuth(`${api.API_URL}/lista-espera`, { method: 'GET' });
        if (!response.ok) throw new Error("Erro ao buscar os dados");
        const result = await response.json();
        const filtradas = filtrarListaFeiraUsuario(result.data);
        setDados(filtradas.map(item => ({
          ...item,
          nome_expositor: item.nome_expositor || 'Não informado',
          area_atuacao: item.area_atuacao || "Não informado"
        })));
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

  useEffect(() => {

    const carregarPaises = async () => {
      try {
        const response = await fetchComAuth(`${api.API_URL}/paises`, {
          method: 'GET'
        });
        const paises = await response.json();
        
        setPaises(paises.data);
       
      } catch (error) {
        console.error("Erro ao carregar o JSON:", error);
      }
    };
    
    fetchDados();
    carregarPaises();
  }, []);

  const handleFeiraChange = (feiraValue) => {
    setFeiraSelecionada(feiraValue);
  };

  const columns = useMemo(
    () => [
      {
        header: "Expositor",
        accessorKey: "nome_expositor",
      },
      {
        header: "Área atuação",
        accessorKey: "area_atuacao",
      },
      {
        header: "Feira",
        accessorFn: (row) => row.feira_id?.toString(),
        id: 'feira_nome', 
        // O cell renderiza o nome para o usuário ver
        cell: (info) => info.row.original.feira?.nome || '--',
        enableColumnFilter: true,
        filterFn: 'equals', // Filtro exato por ID
      },
      {
        header: "E-mail",
        accessorKey: "email",
      },
      {
        header: "Telefone",
        accessorKey: "telefone",
        cell: info => info.getValue() || '-'
      },
      {
        header: "Solicitado em",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            {handleValidDate(cell.getValue())},
            <small className="text-muted"> {handleValidTime(cell.getValue())}</small>
          </>
        ),
      },
      {
        header: "Endereço",
        enableColumnFilter: false,
        cell: (cell) => {
          const espera = cell.row.original;
          return (
            <div className="d-flex flex-column small">
              <span>{espera.rua || ' '} {espera.bairro || ''} {espera.numero || ""} {espera.complemento || ""}</span>
              <span>{espera.cidade || ''} { espera.estado || ""} {espera.pais || ""} </span>
            </div>
          );
        },
      },
      {
        header: "Observação",
        accessorKey: "observacao",
        cell: info => info.getValue() || '-'
      },
    ],
    []
  );

  const filtrarListaFeiraUsuario = (esperas) => {
    if (['JOTAPIX', 'EVOMAP'].includes(userType)) {
      return esperas;
    } else {
      return esperas.filter(espera => 
        espera.feira_id && userFeirasIds.includes(espera.feira_id)
      );
    }
  };

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD/MM/YYYY");
    return date1;
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime = moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
    return updateTime;
  };

  const feirasOptions = useMemo(() => {
    
    if (!userData.feiras || userData.feiras.length === 0) return [];
    
    return userData.feiras.map(f => ({
      value: f.feira.id.toString(),
      label: f.feira.nome|| ''
    })).sort((a, b) => a.label.localeCompare(b.label));
  }, [userData.feiras]);

  const toggleModalLista = () => {
    if (modalLista) { 
      fetchDados();
    }
    setModalLista(!modalLista);
  };

  useEffect(() => {
    if (userData.feiras?.length === 1) {
      const feiraId = userData.feiras[0].feira_id.toString();
      if (feiraSelecionada !== feiraId) {
        setFeiraSelecionada(feiraId);
      }
    }
  }, [userData.feiras, feiraSelecionada]);

  document.title = "Lista de Espera | EVOMAP - Tecnologia que conecta negócios";
  
  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      
      <Container fluid>
        <BreadCrumb title="Lista Espera" pageTitle="EVOMAP" />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-1">
                  <Col sm={10}>
                    <div className="col-sm">
                      <h5 className="card-title mb-0">Lista de Espera</h5>
                    </div>
                  </Col>
                  <Col sm={2}>
                    <Button 
                      color="success" 
                      onClick={toggleModalLista}
                      disabled={!feiraSelecionada}
                      title={!feiraSelecionada ? "Selecione uma feira no filtro antes de adicionar" : ""}
                    >
                        <i className="ri-file-pdf-line align-bottom me-1"></i> Adicionar
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div>
                  {isLoading ? (
                    <Loader />
                  ) : error ? (
                    <Loader error={error} />
                  ) : (
                    <>
                      
                      <ConsultaLista
                        columns={columns}
                        data={dados}
                        isGlobalFilter={true}
                        customPageSize={10}
                        tableClassName="align-middle"
                        theadClassName="table-light text-muted"
                        divClassName="table-responsive table-card mb-1"
                        SearchPlaceholder="Pesquise ..."
                        nomeRelatorio="Lista Espera"
                        filters={[]}
                        feirasOptions={feirasOptions}
                        feiraSelecionada={feiraSelecionada}
                        onFeiraChange={handleFeiraChange}
                      />

                      {dados.length === 0 && (
                        <div className="text-center py-5">
                          <i className="ri-database-2-line fs-1 text-muted"></i>
                          <h5 className="mt-3">Nenhum registro encontrado</h5>
                          <p className="text-muted">Selecione uma feira acima ou utilize o botão Adicionar.</p>
                        </div>
                      )}
                    </>
                  )}
                </div>
                
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      
      <ModalQueroExpor idFeira={feiraSelecionada} isOpen={modalLista} 
      toggle={toggleModalLista} paises={paises}></ModalQueroExpor>
    

    </div>
  );
};

export default ListaEspera;